<template>
  <v-dialog
    v-model="dialog"
    scrollable
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar dense dark color="primary">
        <v-toolbar-title>
          {{
            typeSubscription._id
              ? $t('titles.global.updateModel', {
                  field: $tc('models.typeSubscription'),
                })
              : $t('titles.global.newModel', {
                  field: $tc('models.typeSubscription'),
                })
          }}
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn icon dark @click="cancel">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
        <v-tabs
          slot="extension"
          v-model="tab"
          color="primary"
          slider-color="white"
          centered
        >
          <v-tab>{{ $tc('models.typeSubscription') }}</v-tab>
          <v-tab>{{ $tc('fields.typeSubscriptions.specification', 2) }}</v-tab>
          <v-tab>{{ $tc('fields.typeSubscriptions.typePayment', 2) }}</v-tab>
        </v-tabs>
      </v-toolbar>
      <v-card-text>
        <v-tabs-items v-model="tab">
          <v-tab-item ripple>
            <v-container py-0>
              <v-layout row wrap>
                <v-flex xs12 px-2>
                  <translation-field
                    ref="name"
                    v-model="typeSubscription.name"
                    :label="$t('fields.global.name')"
                    required
                  />
                </v-flex>
                <v-flex md4 xs12 px-2>
                  <v-select
                    v-model="typeSubscription.availableMatches"
                    :items="availableMatches"
                    clearable
                    :label="$t('fields.typeSubscriptions.availableMatches')"
                    :data-vv-name="
                      $t('fields.typeSubscriptions.availableMatches')
                    "
                    :error-messages="
                      errors.collect(
                        $t('fields.typeSubscriptions.availableMatches')
                      )
                    "
                    multiple
                  />
                </v-flex>

                <v-flex md4 xs12 px-2>
                  <!-- <v-text-field
                    v-model.number="typeSubscription.storage"
                    type="number"
                    :label="$t('fields.typeSubscriptions.storage') + ' *'"
                    :data-vv-name="$t('fields.typeSubscriptions.storage')"
                    :error-messages="
                      errors.collect($t('fields.typeSubscriptions.storage'))
                    "
                    v-validate="'required|numeric'"
                  ></v-text-field>-->
                  <v-currency-field
                    v-model="typeSubscription.storage"
                    v-validate="'required|decimal'"
                    :label="$t('fields.typeSubscriptions.storage') + ' *'"
                    :data-vv-name="$t('fields.typeSubscriptions.storage')"
                    :error-messages="
                      errors.collect($t('fields.typeSubscriptions.storage'))
                    "
                    clearable
                  />
                </v-flex>
                <v-flex md4 xs12 px-2>
                  <v-switch
                    v-model="typeSubscription.linkedAccounts"
                    :label="$t('fields.typeSubscriptions.linkedAccounts')"
                    color="primary"
                  />
                </v-flex>
                <v-flex v-if="typeSubscription.linkedAccounts" md4 xs12 px-2>
                  <v-text-field
                    v-model.number="typeSubscription.numberUser"
                    type="number"
                    :label="$t('fields.typeSubscriptions.numberUser')"
                    min="1"
                    step="1"
                    :data-vv-name="$t('fields.typeSubscriptions.numberUser')"
                    :error-messages="
                      errors.collect($t('fields.typeSubscriptions.numberUser'))
                    "
                  />
                </v-flex>
                <v-flex md3 xs12 px-2>
                  <v-checkbox
                    v-model="typeSubscription.active"
                    :label="$t('fields.global.active')"
                    color="primary"
                  />
                </v-flex>
                <v-flex md3 xs12 px-2>
                  <v-checkbox
                    v-model="typeSubscription.showAd"
                    :label="$t('fields.typeSubscriptions.showAd')"
                    color="primary"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item ripple>
            <specifications v-model="specifications" />
          </v-tab-item>
          <v-tab-item ripple>
            <type-payments v-model="typePayments" />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <span style="color: red">(*) &nbsp;</span>
        <span>{{ $t('action.messages.fieldRequired') }}</span>
        <v-spacer />
        <meta-button type="reset" :disabled="loading" @click="clear" />
        <meta-button
          v-if="!typeSubscription._id"
          type="create"
          :loading="loading"
          @click="submit()"
        />
        <meta-button
          v-else
          type="update"
          :loading="loading"
          @click="submit()"
        />
        <meta-button type="cancel" @click="cancel" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

import Specifications from './Specifications'
import TypePayments from './TypePayments'
import TranslationField from '@/components/widgets/Input/TranslationField'
import VCurrencyField from '@/components/widgets/Input/VCurrencyField'
import { parseObject } from '@/helpers/utils'

export default {
  name: 'TypeSubscriptionForm',
  components: {
    TranslationField,
    Specifications,
    TypePayments,
    VCurrencyField,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data() {
    return {
      typeSubscription: {},
      specifications: [],
      typePayments: [],
      dialogSpecification: false,
      dialogTypePayment: false,

      tab: 0,
    }
  },
  watch: {
    dialog(val) {
      if (!val) this.cancel()
    },
    selected: {
      handler: function (val) {
        if (val) {
          this.setObject(val)
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.setObject(this.selected)
  },
  computed: {
    ...mapState({
      selected: (state) => state.typeSubscriptions.selected,
      loading: (state) => state.typeSubscriptions.loading,
    }),
    ...mapGetters({
      availableMatches: 'typeSubscriptions/availableMatches',
    }),
  },
  methods: {
    ...mapActions({
      setCreate: 'typeSubscriptions/create',
      setUpdate: 'typeSubscriptions/update',
      reset: 'typeSubscriptions/reset',
    }),
    setObject(object) {
      this.typeSubscription = parseObject(object)
      this.typeSubscription.name = object.name.slice() || []
      this.specifications = object.specifications.slice() || []
      this.typePayments = object.typePayment.slice() || []
    },
    submit() {
      Promise.all([this.validate(), this.$refs.name.validate()]).then(
        (valid) => {
          if (valid.some((valid) => !valid)) return
          let payload = Object.assign({}, this.typeSubscription)
          payload.typePayment = this.typePayments.slice()
          payload.specifications = this.specifications.slice()
          if (!payload._id) {
            this.setCreate(payload).then(() => {
              this.cancel()
            })
          } else {
            this.setUpdate(payload).then(() => {
              this.cancel()
            })
          }
        }
      )
    },

    cancel() {
      this.$emit('close')
      this.clear()
    },
    clear() {
      this.nextTick(() => {
        this.reset()
        this.tab = 0
        this.specifications = []
        this.typePayments = []
        this.$validator.reset()
        if (this.$refs.name) this.$refs.name.$validator.reset()
      })
    },
  },
}
</script>
